import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { DamageCategoryRequest } from '@/main/models/request/damageCategoryRequest';

export abstract class IDamageCategoryApi {
  abstract saveDamageCategory(
    request: DamageCategoryRequest
  ): Promise<AxiosResponse<Result<any>, any>>;

  abstract inactiveDamageCategory(
    guidDamageCategory: string
  ): Promise<AxiosResponse>;
}
